import type { LocationFilter } from "generated/graphql";
import type { LocationFilterType } from "./types";

export type FilterCounts = Record<LocationFilterType, number> & {
  total: number;
};
const initialiseCount = (): FilterCounts => ({
  geometry: 0,
  total: 0,
});

export const countLocationFilter = (filter: LocationFilter) => {
  const count = initialiseCount();
  if (filter.geometry != null) {
    count.geometry += 1;
    count.total += 1;
  }
  return count;
};

// TODO: [HORT-2795] add tests
export const countLocationFilters = (filters: LocationFilter) => {
  const count = initialiseCount();

  if (filters.and == null || filters.and.length === 0) {
    return count;
  }
  filters.and.forEach((filter) => {
    const filterCount = countLocationFilter(filter);
    count.geometry += filterCount.geometry;
    count.total += filterCount.total;
  });
  return count;
};
